var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"playerstable"}},[_c('table',{staticClass:"list content",attrs:{"name":"players","tag":"div"}},_vm._l((_vm.players),function(ref,id){
var name = ref.name;
var value = ref.value;
var prev = ref.prev;
var next = ref.next;
var hash = ref.hash;
return _c('tr',{key:id,staticClass:"player",style:({color: hash == _vm.vhash ? 'red' : 'black'})},[_c('td',[_vm._v(_vm._s(name))]),_c('td',[_vm._v(_vm._s(prev == null ? "未投票" : _vm.type[prev]))]),_c('td',[_vm._v(_vm._s(next == null ? "未投票" : hash == _vm.vhash ? _vm.type[next] : "投票済"))]),_c('td',[_vm._v(_vm._s(value))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }